import service from '../../utils/request'


const getLearnCenter = (data) => {
    return service({
        url: 'api/toLearnCenter',
        method: 'post',
        data
    })
}
const getCourseCatalog = (data) => {
    return service({
        url: 'api/personal/courseCatalog',
        method: 'post',
        data
    })
}
const getvideoInfo = data => {
    return service({
        url: `api/video/getvideoInfo?vid=${data.vid}&gid=${data.gid}&cid=${data.cid}`,
        method: 'get',
    })
}
const addUserVideoStatusAndLog = data => {
    return service({
        url:'api/video/addUserVideoStatusAndLog',
        method:'post',
        data
    })
}
const StorageTime = data => {
    return service({
        url:'api/video/StorageTime',
        method:'post',
        data
    })
}

export {
    getLearnCenter,
    getCourseCatalog,
    getvideoInfo,
    addUserVideoStatusAndLog,
    StorageTime
}